import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRefresh05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 27"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 22.746a9.6 9.6 0 0 1-5.28-17.62m6.734-1.47c4.612.7 8.146 4.682 8.146 9.49a9.6 9.6 0 0 1-4.572 8.18M13.2 6.09l-2.546-2.545L13.201 1zm-2.547 14.11 2.546 2.545-2.546 2.546z"
    />
  </svg>
);
export default SvgArrowRefresh05;
